import { Modal, Input, Form, Alert } from 'antd';
import { useEffect } from 'react';
import type { WithdrawBody } from '@/api/cases';

/**
 * 撤回弹窗（任意非终止态 → withdrawn）。
 *
 * 后端契约：POST /declaration-cases/{id}/withdraw
 *   body: { reason?: string }
 *
 * 注：撤回为终止态。后端当前临时把 reason 写入 review_comments
 * （见 declaration_cases.py:471-473 — M3-ε 接入 audit_log 后须拆出）。
 */
export interface WithdrawModalProps {
  open: boolean;
  loading?: boolean;
  onCancel: () => void;
  onSubmit: (body: WithdrawBody) => void;
}

export function WithdrawModal({
  open,
  loading,
  onCancel,
  onSubmit,
}: WithdrawModalProps) {
  const [form] = Form.useForm<{ reason?: string }>();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  return (
    <Modal
      title="撤回申报案"
      open={open}
      onCancel={onCancel}
      okText="确认撤回"
      cancelText="取消"
      okButtonProps={{ danger: true }}
      confirmLoading={loading}
      onOk={async () => {
        try {
          const values = await form.validateFields();
          onSubmit({ reason: values.reason?.trim() || undefined });
        } catch {
          /* noop */
        }
      }}
      destroyOnClose
    >
      <Alert
        type="warning"
        showIcon
        message="撤回后状态为终止态，不可再恢复"
        style={{ marginBottom: 'var(--space-3)' }}
      />
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item name="reason" label="撤回原因（可选）">
          <Input.TextArea
            rows={3}
            placeholder="如：材料缺失 / 主体重复申报 / 政策包升级…"
            maxLength={500}
            showCount
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
